import { MenuOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { Button, Col, Divider, Row } from 'components';
import { theme } from 'configs/styled';
import { FormikProps, FormikValues } from 'formik';
import React from 'react';
import LogoutButton from './LogoutButton';

interface ILogout {
  disabledDivider?: boolean;
  formik?: FormikProps<FormikValues>;
}

const Logout: React.FC<ILogout> = props => {
  const { disabledDivider, formik } = props;
  return (
    <Row style={{ margin: `0px ${theme.spacing.xs}` }}>
      <Col xs={0} sm={0} md={0} lg={24}>
        {!disabledDivider && (
          <Divider
            style={{
              height: theme.elementSize.navbarDividerHeight,
              width: 1,
              textAlign: 'center',
              background: theme.palettes.border,
            }}
            orientation="center"
            type="vertical"
          />
        )}
        <LogoutButton formik={formik} />
      </Col>
      <Col sm={24} xs={24} md={24} lg={0}>
        <Dropdown
          overlay={<LogoutButton formik={formik} />}
          trigger={['click']}
        >
          <Button>
            <MenuOutlined />
          </Button>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default Logout;
